import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HomePageButtonGeneral from 'components/temoraryHomePage/HomePageButtonGeneral';
import { Icon } from 'components/shared';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

const Footer = styled.div`
  padding: 20px 1em
  border-radius: 10px;
`;
const IconDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  color: #fff;
`;

const HomePageButtonNew = ({ children }) => (
  <Footer>
    <HomePageButtonGeneral size="volatile">
      {children}
      <IconDiv>
        <Icon icon='forwardArrow' width='1.25' />
      </IconDiv>
    </HomePageButtonGeneral>
  </Footer>
);

HomePageButtonNew.propTypes = propTypes;

export default HomePageButtonNew;
